export default function BtnA() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.83593 0H4.83593V3.9998L0.835938 3.9998V5.9998H4.83593V10H6.83593V5.9998H10.8359V3.9998L6.83593 3.9998V0Z"
                fill="black"
            />
        </svg>
    );
}
